var React = require('react');
var CreateReactClass = require('create-react-class');
var PropTypes = require('prop-types');

import './button.component.css';

var Button = CreateReactClass({
    getInitialState: function () {
        return {
            style: {},
        };
    },
    propTypes : {
        onClick:  PropTypes.func,
        color : PropTypes.string,
        disabled : PropTypes.bool,
        text : PropTypes.string,
        faIcone : PropTypes.string,
        faIconeSize : PropTypes.string,
        minwidth : PropTypes.number,
        fontcolor : PropTypes.string
    },
    componentDidMount() {
        var styleNoClick = {
            background : this.props.color,
            borderColor: this.props.color,
            minWidth : this.props.minwidth
        };
        this.setState({style : styleNoClick});
    },
    defaultProps : {
        onClick : function(){},
        disabled : false,
        text : 'click me',
        faIcone : '',
        faIconeSize : '',
        color : '#818181',
        minwidth : 20,
        fontcolor : '#ddd'
    },
    handleClick : function(){
        var that = this;

        var styleOnClick = {
            opacity: 0.6,
            background : this.props.color,
            borderColor: this.props.color,
            minWidth : this.props.minwidth
        };

        var styleNoClick = {
            background : this.props.color,
            borderColor: this.props.color,
            minWidth : this.props.minwidth
        };

        that.setState({style : styleOnClick});
        setTimeout(function(){that.setState({style : styleNoClick})}, 100);
        this.props.onClick();
    },

    render: function () {
        var renderFaIcone = function(faItem, faItemSize){
            if (!faItem){
                return '';
            }
            else {
                var className = "fa " + faItem + " "+ faItemSize;
                return (
                    <span style={{paddingRight : 7}}
                          className={className} aria-hidden="true">
                    </span>) ;
            }

        };
        var renderClass = function(disabled){
            if (!disabled){
                return 'buttonContent_abled';
            }
            else {
                return 'buttonContent_disabled';
            }
        };

        return (
            <div className="buttonD"  style={{color : this.props.fontcolor}}>
                <div className={"buttonContent ligneFlexCenteredCentered " + renderClass(this.props.disabled)}  style={this.state.style} type="button" onClick={this.handleClick} >
                    {renderFaIcone(this.props.faIcone, this.props.faIconeSize)}
                    <span>{this.props.text}</span>
                </div>
            </div>
        );
    }
});

module.exports = Button;



// WEBPACK FOOTER //
// ./src/components/common/button.component.js